// extracted by mini-css-extract-plugin
export default {"header":"CollectionTableHeader_header__M3hYN"};